import { _ } from "../../../core/polyglot/polyglot.js";
import { Widget } from "@foretagsplatsen/widgetjs";
import ButtonWithHelpText from "../../../core/widgets/ButtonWithHelpText/ButtonWithHelpText.js";
import FloatingFooter from "../../../core/widgets/FloatingFooter.js";

/**
 * Banner displaying a message and a button to collect company user acknowledgment.
 * The banner is displayed at the bottom of the window and activates when
 * the bottom of the document is reached.
 *
 * @param {function} onClick - Button click handler
 */
export default class AcknowledgementBanner extends Widget {
	constructor({ onClick }) {
		super(...arguments);
		this._endOfDocumentReached = false;

		this._confirmButton = new ButtonWithHelpText({
			helpText: _("Scroll down the report to click"),
			onClick,
		});

		const message = _(
			"I acknowledge that I have received and understood this report",
		);

		this._floatingFooter = new FloatingFooter({
			content: (html) => {
				html.p({ klass: "message" }, message);
				html.div({ klass: "actions" }, this._confirmButton);
			},
		});
	}

	renderContentOn(html) {
		html.render(this._floatingFooter);
	}

	_createScrollHandler(viewport) {
		const handler = () => {
			const height = viewport.scrollHeight;
			// Value is rounded to be sure Edge can go all the way down
			const scrollPosition = Math.round(viewport.scrollTop);
			const offset = viewport.offsetHeight;

			// Even though we remove the event, the browser already fired a couple of similar
			// events already. To avoid multiple update, we reinforce the condition here.
			// (we check for superior values as well because of browsers rounding calculations)
			if (
				scrollPosition + offset >= height &&
				!this._endOfDocumentReached
			) {
				this._endOfDocumentReached = true;
				this._confirmButton.setEnabled();
				viewport.removeEventListener("scroll", handler);
			}
		};

		return handler;
	}

	_didAttach() {
		super._didAttach();
		const viewport = document.getElementById("viewport");

		viewport.addEventListener(
			"scroll",
			this._createScrollHandler(viewport),
		);
	}
}
